/**
 * The framework's cart identity, restated because ui-components 0.3.4 does not
 * export `cartSignature` (ORDR-42).
 *
 * `CustomerOrdering` treats a priced cart as current only when
 * `priced.cartSignature === cartSignature(lines)`, so the signature this app
 * stamps on the server quote must be the framework's exactly. Transcribed from
 * `shell/customer/pricing.ts` as published in 0.3.4.
 *
 * `customerRoute.test.tsx` guards the agreement BEHAVIOURALLY: a quoted cart
 * must reach the payment step in the real framework component. A drifted
 * signature leaves the diner at "your order's price is out of date" and that
 * test fails.
 */

import type { CartLine } from "../framework/types.js";

export function cartSignature(lines: readonly CartLine[]): string {
  return lines
    .map((line) => {
      const selections = Object.keys(line.selections)
        .sort()
        .map((group) => {
          const options = [...new Set(line.selections[group] ?? [])].sort();
          return `${group}=${options.join(",")}`;
        })
        .join(";");
      return `${line.menuItemId}*${String(line.quantity)}(${selections})`;
    })
    .sort()
    .join("|");
}
